<template>
    <div v-if="permissionsShow">
        <el-time-select
            v-if="type == 'fixedTime'"
            v-model="currentValue"
            :style="dateStyle"
            :readonly="readonly"
            :disabled="disabled"
            :picker-options="pickerOptions"
            :placeholder="placeholder"
            :default-value="defaultValue"
            :default-time="defaultTime"
            :prefix-icon="prefixIcon"
            :validate-event="validateEvent"
            :clearable="clearable"
            :editable="editable"
            :size="size"
            @change="_change"
            @blur="_blur"
            @focus="_focus"
        >
        </el-time-select>
        <el-time-picker
            v-else-if="type == 'time'"
            v-model="currentValue"
            :style="dateStyle"
            :readonly="readonly"
            :disabled="disabled"
            :is-range="isRange"
            :type="type"
            :picker-options="pickerOptions"
            :placeholder="placeholder"
            :start-placeholder="startPlaceholder"
            :end-placeholder="endPlaceholder"
            :format="format"
            :range-separator="separator"
            :align="align"
            :default-value="defaultValue"
            :default-time="defaultTime"
            :value-format="valueFormat"
            :prefix-icon="prefixIcon"
            :validate-event="validateEvent"
            :clearable="clearable"
            :editable="editable"
            :size="size"
            @change="_change"
            @blur="_blur"
            @focus="_focus"
        >
        </el-time-picker>
        <el-date-picker
            v-else
            v-model="currentValue"
            :style="dateStyle"
            :readonly="readonly"
            :disabled="disabled"
            :placeholder="placeholder"
            :start-placeholder="startPlaceholder"
            :end-placeholder="endPlaceholder"
            :type="type"
            :format="format"
            :range-separator="separator"
            :picker-options="pickerOptions"
            :align="align"
            :default-value="defaultValue"
            :default-time="defaultTime"
            :value-format="valueFormat"
            :prefix-icon="prefixIcon"
            :validate-event="validateEvent"
            :unlink-panels="unlinkPanels"
            :clearable="clearable"
            :editable="editable"
            :size="size"
            @change="_change"
            @blur="_blur"
            @focus="_focus"
        >
        </el-date-picker>
    </div>
</template>
<script>
export default {
    data() {
        return {
            currentValue: this.value,
            minTime: this.minTime,
            maxTime: this.maxTime,
            /* 是否满足显示权限 */
            permissionsShow: true
        };
    },
    props: {
        /* 默认值 */
        value: {
            type: [Date, String, Array],
            default: function() {
                if (this.type !== 'fixedTime') {
                    return new Date();
                }
                return '';
            }
        },
        disabled: Boolean,
        /* 当前时间日期选择器特有的选项 */
        pickerOptions: {
            type: Object,
            default: function() {
                return {
                    start: '00:00',
                    step: '00:30',
                    end: '24:00'
                };
            }
        },
        /* 完全只读 */
        readonly: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 文本框可输入 */
        editable: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 是否显示清除按钮 */
        clearable: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 输入框尺寸 medium / small / mini */
        size: {
            type: String,
            default: function() {
                return 'medium';
            }
        },
        /* 显示类型  fixedTime/timeyear/month/date/dates/ week/datetime/datetimerange/daterange */
        type: {
            default: function() {
                return 'datetime';
            }
        },
        /* 占位符 */
        placeholder: {
            type: String,
            default: function() {
                return this.$t('component.PLEASE_SELECT_TIME');
            }
        },
        /* 范围选择时开始日期的占位内容 */
        startPlaceholder: {
            type: String,
            default: function() {
                return this.$t('component.STAERT_TIME');
            }
        },
        /* 范围选择时结束日期的占位内容 */
        endPlaceholder: {
            type: String,
            default: function() {
                return this.$t('component.END_TIME');
            }
        },
        /* 是否使用箭头进行时间选择，仅对<el-time-picker>有效 */
        arrowControl: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 对齐方式 left / center / right */
        align: {
            type: String,
            default: function() {
                return 'left';
            }
        },
        /* 可选，选择器打开时默认显示的时间 */
        defaultValue: {
            type: Date,
            default: function() {
                return new Date();
            }
        },
        /* 范围选择时选中日期所使用的当日内具体时刻 */
        defaultTime: {
            type: [Array, String]
        },
        /* 自定义头部图标的类名 */
        prefixIcon: {
            type: String
        },
        /* 输入时是否触发表单的校验 */
        validateEvent: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 是否为时间范围选择，仅对<el-time-picker>有效 */
        isRange: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 选择范围时的分隔符 */
        separator: {
            type: String
        },
        /* 左右是否联动 */
        unlinkPanels: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 可选，绑定值的格式。不指定则绑定值为 Date 对象 */
        valueFormat: {
            type: String,
            default: function() {
                if (this.type === 'time') {
                    return 'HH:mm:ss';
                } else if (this.type === 'year') {
                    return 'yyyy';
                } else if (this.type === 'month') {
                    return 'yyyy-MM';
                } else if (this.type === 'datetime' || this.type === 'datetimerange') {
                    return 'yyyy-MM-dd HH:mm:ss';
                } else if (this.type === 'date' || this.type === 'dates') {
                    return 'yyyy-MM-dd';
                }
                return '';
            }
        },
        format: {
            type: String,
            default: function() {
                if (this.type === 'week') {
                    return 'yyyy-WW';
                } else if (this.type === 'time') {
                    return 'HH:mm:ss';
                } else if (this.type === 'year') {
                    return 'yyyy';
                } else if (this.type === 'month') {
                    return 'yyyy-MM';
                } else if (this.type === 'datetime' || this.type === 'datetimerange') {
                    return 'yyyy-MM-dd HH:mm:ss';
                } else if (this.type === 'date' || this.type === 'dates') {
                    return 'yyyy-MM-dd';
                }
                return '';
            }
        },
        dateStyle: {
            type: String
        },
        /* 所有权限信息 */
        permissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 角色信息 */
        roles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 权限之一 */
        oneOfPermissions: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    created() {
        /* 权限数据处理 */
        if (this.permissions.length > 0 || this.oneOfPermissions.length > 0 || this.roles.length > 0) {
            this.permissionsShow = this.dealPermissions(this.permissions, this.roles, this.oneOfPermissions);
        }
    },
    watch: {
        value(newvel) {
            this.currentValue = newvel;
        },
        minTime(newvel) {
            this.minTime = newvel;
        },
        maxTime(newvel) {
            this.maxTime = newvel;
        },
        type(newvel) {
            this.type = newvel;
        }
    },
    methods: {
        /* 用户确认选定的值时触发 */
        _change(val) {
            this.$emit('input', val);
            this.$emit('change', val);
        },
        /* 当input失去焦点时触发 */
        _blur(val) {
            this.$emit('blur', val);
        },
        /* 当 input 获得焦点时触发 */
        _focus(val) {
            this.$emit('focus', val);
        }
    }
};
</script>
<style>
.el-date-editor.el-input {
    width: 200px !important;
}
.el-date-editor--timerange.el-input__inner {
    width: 200px !important;
}
.el-date-editor--datetimerange.el-input__inner {
    width: 350px !important;
}
.el-range-editor.el-input__inner {
    padding: 3px 5px !important;
}
</style>
